// src/utils/dashboardUtils.ts
import moment from 'moment';
import { periodOptions as periodDropdownOptions } from '../Juno/Pages/Account/Dashboards/utils';
import {
    DAYS_15,
    DAYS_455,
    DAYS_63,
    DAY_1,
    HOURS_3,
    HOUR_1,
    MINUTE_1,
    MINUTE_15,
    MINUTE_5,
    SEC_1,
} from '../Juno/Pages/Account/Dashboards/constants';

export const createHandleDateChange = (
    periodOptions,
    selectedPeriod,
    setPeriodOptions,
    setSelectedPeriod,
    setDate,
    setMetricRange,
    toastNotifications
) => {
    return ({ detail }) => {
        var startMoment, endMoment;

        if ('absolute' === detail.value.type) {
            startMoment = moment(detail.value.startDate);
            endMoment = moment(detail.value.endDate);
        } else if ('relative' === detail.value.type) {
            startMoment = moment().subtract(detail.value.amount, detail.value.unit);
            endMoment = moment();
        }

        if (
            !startMoment ||
            !startMoment.isValid() ||
            startMoment.isBefore(moment().subtract(14, 'months'))
        ) {
            toastNotifications.addDanger(
                'Invalid start date, it can not be older than 14 months'
            );
            return;
        }

        if (!endMoment || !endMoment.isValid() || endMoment.isAfter(moment())) {
            toastNotifications.addDanger(
                'Invalid end date, it can not be future date'
            );
            return;
        }

        var duration = moment.duration(endMoment.diff(startMoment)).asSeconds();
        var newPeriodOptions = periodDropdownOptions.map((a) => {
            return { ...a };
        });

        let disableOption = (optionToBeDisabled) => {
            newPeriodOptions.find((option, i) => {
                if (option.text === optionToBeDisabled) {
                    newPeriodOptions[i]['disabled'] = true;
                    return true;
                }
            });
        };

        let setPeriod = (periodToBeSet) => {
            setSelectedPeriod(
                periodOptions.find((option) => option.text === periodToBeSet)
            );
        };

        // metric retention conditions
        if (duration > HOURS_3 && duration <= DAYS_15) {
            disableOption(SEC_1);
        }
        if (duration > DAYS_15 && duration <= DAYS_63) {
            disableOption(SEC_1);
            disableOption(MINUTE_1);
        }
        if (duration > DAYS_63 && duration <= DAYS_455) {
            disableOption(SEC_1);
            disableOption(MINUTE_1);
            disableOption(MINUTE_5);
        }
        if (duration > DAYS_455) {
            disableOption(SEC_1);
            disableOption(MINUTE_1);
            disableOption(MINUTE_5);
            disableOption(MINUTE_15);
            disableOption(HOUR_1);
        }

        // disabling period options greater than the selected duration
        if (duration < DAY_1) {
            disableOption(DAY_1);
        }
        if (duration < HOUR_1) {
            disableOption(HOUR_1);
        }
        if (duration < MINUTE_15) {
            disableOption(MINUTE_15);
        }
        if (duration < MINUTE_5) {
            disableOption(MINUTE_5);
        }
        if (duration < MINUTE_1) {
            disableOption(MINUTE_1);
        }

        // setting period for default relative date options
        if ('relative' === detail.value.type) {
            let val = detail.value.amount + ' ' + detail.value.unit;
            if (val === '6 hour' || val === '1 day') {
                setPeriod(MINUTE_1);
            }
            if (val === '3 day' || val === '1 week') {
                setPeriod(MINUTE_5);
            }
            if (val === '3 week') {
                setPeriod(MINUTE_15);
            }
        }

        setPeriodOptions(newPeriodOptions);
        setDate(detail.value);
        setMetricRange({
            startTime: startMoment.unix(),
            endTime: endMoment.unix(),
            period: selectedPeriod.text,
        });
    };
};
